<template>
  <div class="topbar">
    <div class="logo">
      <router-link @click.native="closeMenu" to="/">
        <img src="@/assets/logo.png" />
      </router-link>
    </div>
    <div @click="show = true" class="menu">
      <img src="@/assets/menu.png" />
    </div>
    <!-- 菜单 -->
    <van-popup v-model="show" position="right" :style="{ height: '100%', width: '100%' }">
      <div class="menu_top">
        <div class="logo">
          <img src="@/assets/logo.png" />
        </div>
        <div @click="show = false" class="close">
          <img src="@/assets/menu_close.png" />
        </div>
      </div>
      <div class="menu_body">
        <div class="nav_list">
          <router-link @click.native="closeMenu" to="/home">网站首页</router-link>
        </div>
        <div class="nav_list">
          <router-link @click.native="closeMenu" to="/about">关于我们</router-link>
        </div>
        <div class="nav_list">
          <router-link @click.native="closeMenu" to="/product">产品中心</router-link>
        </div>
        <div class="nav_list">
          <router-link @click.native="closeMenu" to="/news">新闻中心</router-link>
        </div>
        <div class="nav_list">
          <router-link @click.native="closeMenu" to="/contact">联系我们</router-link>
        </div>
        <div class="nav_list">
          <router-link @click.native="closeMenu" to="/after">服务中心</router-link>
        </div>
        <div v-if="showObj.information" class="nav_list">
          <router-link  @click.native="closeMenu" to="/information">资料下载</router-link>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'topBar',
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters(['showObj'])
  },
  methods: {
    closeMenu() {
      this.show = false
    }
  },
}
</script>

<style lang="scss" scoped>
.topbar {
  height: 44px;
  background: #020911;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    width: 88px;
    height: 32px;
    img {
      width: 88px;
      height: 32px;
    }
  }
  .menu {
    width: 32px;
    height: 32px;
    img {
      width: 32px;
      height: 32px;
    }
  }
}

.menu_top {
  height: 44px;
  background: #020911;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    width: 88px;
    height: 32px;
    img {
      width: 88px;
      height: 32px;
    }
  }
  .close {
    width: 18px;
    height: 18px;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.menu_body {
  padding-top: 60px;
  width: 200px;
  margin: 0 auto;
  .nav_list {
    margin-top: 10px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    text-align: center;
    color: rgba(0, 0, 0, 0.9);
    a {
      font-size: 20px;
      line-height: 28px;
      color: rgba(0, 0, 0, 0.9);
    }
    .router-link-active {
      font-weight: bold;
      color: #0049f0;
    }
  }
}
</style>
